import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Input} from "antd"

class NumberFilterOptions extends Component {
    render() {
        const {defaultValue, handleChange, label, field, placeholder} = this.props

        return (
            <div className='SelectFilterOption'>
                {label && <label className="font-weight-bold d-block">{label}</label>}
                <Input
                    name={field}
                    type='number'
                    value={defaultValue}
                    min={1}
                    placeholder={placeholder}
                    style={{width: 100, marginTop:(!label ? '29px': 'unset')}}
                    onChange={handleChange}
                />
            </div>
        )
    }
}

NumberFilterOptions.defaultProps = {
    label: '',
    placeholder: '',
}

NumberFilterOptions.propTypes = {
    placeholder: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
    field: PropTypes.string.isRequired,
    label: PropTypes.string
}

export default NumberFilterOptions